/* angular:styles/component:css;3d25771dc1ed45f2471931448ebe12fff4537ff2dca5de0a2c0e1a932627a102;/home/vsts/work/1/s/OrcaRoeien.Angular/src/app/modules/shared/components/datepicker-ag-grid/datepicker-ag-grid.component.ts */
mat-form-field {
  background-color: #eee;
}
.container {
  width: 350px;
}
/*# sourceMappingURL=datepicker-ag-grid.component.css.map */
